import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  NbDialogRef,
  NbToastrService
} from '@nebular/theme';
import { FirebaseRepositoryService } from '../../firebase-repository.service';

interface Producto {
  identifier: number;
  name: string;
  [key: string]: any;
}

interface VariedadCultivo {
  codCultivo: number;
  codEppo: string;
  identifier: number;
  name: string;
}

@Component({
  selector: 'ngx-editar-recinto',
  templateUrl: './editar-recinto.component.html',
  styleUrls: ['./editar-recinto.component.scss']
})
export class EditarRecintoComponent implements OnInit {

  parcela: any;

  alias = '';
  codigoDGC = '';

  cultivos: Producto[] = [];
  variedades: VariedadCultivo[] = [];
  variedadesFiltradas: VariedadCultivo[] = [];

  cultivoSeleccionado: number | null = null;
  variedadSeleccionada: number | null = null;

  cargandoDatos = true;
  loading = false;

  private cargasCompletadas = 0;

  constructor(
    protected dialogRef: NbDialogRef<EditarRecintoComponent>,
    private repoService: FirebaseRepositoryService,
    private toastrService: NbToastrService,
    private httpClient: HttpClient
  ) {}

  ngOnInit(): void {

    this.alias = this.parcela?.alias || '';
    this.codigoDGC = this.parcela?.codigoDGC || '';

    this.cargarCultivos();
    this.cargarVariedades();
  }

  private cargarCultivos(): void {

    this.httpClient
      .get<Producto[]>('../assets/jsondata/productos.json')
      .subscribe({

        next: items => {

          this.cultivos = items || [];

          this.comprobarCargaDatos();
        },

        error: error => {

          console.error(
            'Error al cargar productos.json:',
            error
          );

          this.toastrService.danger(
            'No se han podido cargar los cultivos.',
            'Error'
          );

          this.comprobarCargaDatos();
        }

      });
  }

  private cargarVariedades(): void {

    this.httpClient
      .get<VariedadCultivo[]>(
        '../assets/jsondata/variedadCultivo.json'
      )
      .subscribe({

        next: items => {

          this.variedades = items || [];

          this.comprobarCargaDatos();
        },

        error: error => {

          console.error(
            'Error al cargar variedadCultivo.json:',
            error
          );

          this.toastrService.danger(
            'No se han podido cargar las variedades.',
            'Error'
          );

          this.comprobarCargaDatos();
        }

      });
  }

  private comprobarCargaDatos(): void {
    this.cargasCompletadas++;
    if (this.cargasCompletadas >= 2) {
      this.cargandoDatos = false;
      this.inicializarSeleccion();
    }
  }

  private inicializarSeleccion(): void {

    const nombreCultivo =
      this.parcela?.campania?.cultivo;

    const nombreVariedad =
      this.parcela?.campania?.variedad;

    // Buscar cultivo por nombre
    if (nombreCultivo) {

      const cultivo = this.cultivos.find(
        item =>
          item.name?.trim().toUpperCase() ===
          nombreCultivo.trim().toUpperCase()
      );

      if (cultivo) {

        this.cultivoSeleccionado =
          cultivo.identifier;
      }
    }

    // Filtrar variedades del cultivo
    this.filtrarVariedades();

    // Buscar variedad por nombre
    if (nombreVariedad) {

      const variedad = this.variedadesFiltradas.find(
        item =>
          item.name?.trim().toUpperCase() ===
          nombreVariedad.trim().toUpperCase()
      );

      if (variedad) {

        this.variedadSeleccionada =
          variedad.identifier;
      }
    }
  }

  cambioCultivo(): void {
    this.variedadSeleccionada = null;
    this.filtrarVariedades();
  }

  private filtrarVariedades(): void {

    if (this.cultivoSeleccionado == null) {
      this.variedadesFiltradas = [];
      return;
    }

    this.variedadesFiltradas =
      this.variedades.filter(
        variedad =>
          variedad.codCultivo ===
          this.cultivoSeleccionado
      );

    // Si estamos editando y la variedad actual
    // pertenece al cultivo seleccionado, la mantenemos.
    if (
      this.variedadSeleccionada != null &&
      !this.variedadesFiltradas.some(
        variedad =>
          variedad.identifier ===
          this.variedadSeleccionada
      )
    ) {
      this.variedadSeleccionada = null;
    }
  }

  guardar(): void {

    if (!this.alias.trim()) {

      this.toastrService.warning(
        'Debe informar el nombre de la parcela.',
        'Editar recinto'
      );

      return;
    }

    if (!String(this.codigoDGC ?? '').trim()) {

      this.toastrService.warning(
        'Debe informar el código DGC.',
        'Editar recinto'
      );

      return;
    }

    if (this.cultivoSeleccionado == null) {

      this.toastrService.warning(
        'Debe seleccionar un cultivo.',
        'Editar recinto'
      );

      return;
    }

    if (this.variedadSeleccionada == null) {

      this.toastrService.warning(
        'Debe seleccionar una variedad.',
        'Editar recinto'
      );

      return;
    }

    const cultivo =
      this.cultivos.find(
        item =>
          item.identifier ===
          this.cultivoSeleccionado
      );

    const variedad =
      this.variedades.find(
        item =>
          item.codCultivo ===
            this.cultivoSeleccionado &&
          item.identifier ===
            this.variedadSeleccionada
      );

    if (!cultivo || !variedad) {

      this.toastrService.danger(
        'No se han podido obtener los datos del cultivo o variedad.',
        'Error'
      );

      return;
    }

    const datos = {
      idowner: this.parcela.userOwner,
      id: this.parcela.id,
      codCultivo: this.cultivoSeleccionado,
      cultivo: cultivo.name,
      codVariedad: this.variedadSeleccionada,
      variedad: variedad.name,
      codigoDGC: String(this.codigoDGC ?? '').trim(),
      alias: this.alias.trim()
    };

    this.loading = true;

    this.repoService
      .modificarRecinto(datos)
      .subscribe({

        next: response => {

          console.log('[MODIFICAR_RECINTO] Response:', response);

          this.loading = false;

          this.toastrService.success(
            'El recinto se ha modificado correctamente.',
            'Editar recinto'
          );

          this.dialogRef.close(true);
        },

        error: error => {

          console.error('[MODIFICAR_RECINTO] Error:', error);

          this.loading = false;

          this.toastrService.danger(
            'No se ha podido modificar el recinto.',
            'Error'
          );
        }

      });
  }

  cerrar(): void {

    if (this.loading) {
      return;
    }

    this.dialogRef.close(false);
  }
}